module.exports = __webpack_public_path__ + "img/0Q3A3733_L_Wood.5977efb4.jpg";